import React from "react"
import { createDomMotionComponent } from "framer-motion"

import { Icon } from "../../icon"

import { buttonStyles, scrimStyles, iconStyles } from "./_Styles"
import { buttonVariants, scrimVariants, iconVariants } from "./_Variants"

const motion = {
  div: createDomMotionComponent("div"),
  button: createDomMotionComponent("button"),
}

function CarouselNavigation({
  nextDisabled,
  nextOnClick,
  prevDisabled,
  prevOnClick,
}) {
  return (
    <div
      data-component="CarouselNavigation"
      className="space-x-0.5 inline-flex"
    >
      <motion.button
        className={buttonStyles(prevDisabled)}
        disabled={prevDisabled}
        onClick={prevOnClick}
        initial="initial"
        whileFocus="hover"
        whileHover="hover"
        whileTap="tap"
        variants={buttonVariants}
      >
        <motion.div
          data-component="iconButton.scrim"
          className={scrimStyles}
          variants={scrimVariants}
        />
        <motion.div
          data-component="iconButton.icon"
          className={iconStyles}
          variants={iconVariants}
        >
          <Icon aria-hidden symbol="chevron-left" size={16} />
          <span className="sr-only">Previous</span>
        </motion.div>
      </motion.button>
      <motion.button
        className={buttonStyles(nextDisabled)}
        disabled={nextDisabled}
        onClick={nextOnClick}
        initial="initial"
        whileFocus="hover"
        whileHover="hover"
        whileTap="tap"
        variants={buttonVariants}
      >
        <motion.div
          data-component="iconButton.scrim"
          className={scrimStyles}
          variants={scrimVariants}
        />
        <motion.div
          data-component="iconButton.icon"
          className={iconStyles}
          variants={iconVariants}
        >
          <Icon aria-hidden symbol="chevron-right" size={16} />
          <span className="sr-only">Next</span>
        </motion.div>
      </motion.button>
    </div>
  )
}

export default CarouselNavigation
